import styled from 'styled-components'

export const Box = styled.div<{ $backgroundColor: string }>`
  display: flex;
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? `var(${$backgroundColor})` : 'var(--primary100)'};
  border-radius: 8px;
  width: 100%;
  // height: 120px;
  padding: 24px 16px;
  cursor: pointer;
`

export const Label = styled.div`
  span {
    background: var(--gray500);
    color: var(--gray100);
    border-radius: 4px;
    padding: 2px 4px;
  }
`
export const Image = styled.img`
  width: 64px;
  height: 64px;
`
